import { CollectCoin } from '@/components/CollectCoin'
import { PageRoutes } from '@/constants/PageRoutes'
import { useI18n } from 'i18n-utils'
import { useDoubleContractKlineStore, useResponsive, useUserInfoStore } from 'store'
import { CustomButton, DialogHeader, HocElDialog } from 'ui-components'
import '../styles/trade-orderer-layout.scss'
import { OrdererBuy } from './OrdererBuy'

export const TradeOrderer = defineComponent({
  setup() {
    const openOrderer = ref(false)
    const currentOrderType = ref<'buy' | 'sell'>()

    const { t } = useI18n()
    const router = useRouter()
    const responsive = useResponsive()
    const userInfoStore = useUserInfoStore()
    const klineStore = useDoubleContractKlineStore()

    const onBuy = () => {
      if (!userInfoStore.isLogin) {
        router.push(PageRoutes.Login)
        return
      }
      openOrderer.value = true
      currentOrderType.value = 'buy'
    }

    const onSell = () => {
      if (!userInfoStore.isLogin) {
        router.push({
          path: PageRoutes.Register,
          query: {
            entry: 'contract_trade',
          },
        })
        return
      }
      openOrderer.value = true
      currentOrderType.value = 'sell'
    }

    const onClose = () => {
      openOrderer.value = false
      currentOrderType.value = undefined
    }

    return () => {
      if (!responsive.isMobile) {
        return (
          <div class="contract-trade-orderer-layout">
            <div class="orderer-box">
              <OrdererBuy activeTab={currentOrderType.value} />
            </div>
          </div>
        )
      }
      return (
        <div class="contract-trade-orderer-layout">
          <div class="mobile-orderer-box">
            <div class="mobile-orderer-button">
              <CustomButton type={'primary'} primaryColor="var(--colors-up)" onClick={onBuy}>
                {userInfoStore.isLogin ? t('开多') : t('登录')}
              </CustomButton>
              <CustomButton type={'primary'} primaryColor="var(--colors-down)" onClick={onSell}>
                {userInfoStore.isLogin ? t('开空') : t('注册')}
              </CustomButton>
              <div class={'collect-wrapper'}>
                <CollectCoin symbolId={klineStore.currentSymbolId!} />
                <span class={'collect-text'}>{t('自选')}</span>
              </div>
            </div>

            <HocElDialog v-model={openOrderer.value} showClose={false} placement="bottom" onClose={onClose}>
              {{
                header: () => <DialogHeader onClose={onClose}>{t('U本位合约')}</DialogHeader>,
                default: () => <OrdererBuy activeTab={currentOrderType.value} onClose={onClose} />,
              }}
            </HocElDialog>
          </div>
        </div>
      )
    }
  },
})
